import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconSeismic2DS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.5 6.2075C5.298 6.46378 4.44856 7.1717 3.75654 7.74842C3.48391 7.97563 3.2357 8.18248 3 8.33333L3 11C3.71088 10.4313 5.08123 9.54241 6.5 9.08756L6.5 6.2075Z"
        fill="#FF4443"
      />
      <path
        d="M9.5 8.96113C11.1863 9.08038 12.5077 8.27264 13 7.8V3C12.3417 3.84262 10.8929 5.53914 9.5 6.06593L9.5 8.96113Z"
        fill="#FF4443"
      />
      <path
        d="M6.5 9.58472C5.35205 9.44321 4.15317 9.36576 3 10L3 13C3.70223 12.5138 5.09488 11.5716 6.5 11.1545L6.5 9.58472Z"
        fill="#56B9F2"
      />
      <path
        d="M9.5 11.379C11.1675 11.7664 12.3979 10.7352 12.9333 10.2865C12.9569 10.2668 12.9791 10.2481 13 10.2308V7C12.3407 7.73034 10.8988 9.03852 9.5 9.55297V11.379Z"
        fill="#56B9F2"
      />
      <path
        d="M6.5 3L3 3C2.44772 3 2 3.44772 2 4L2 12C2 12.5523 2.44772 13 3 13H6.5V12H3L3 4L6.5 4V3Z"
        fill="#97B2C4"
      />
      <path
        d="M9.5 12H13L13 4L9.5 4V3L13 3C13.5523 3 14 3.44772 14 4L14 12C14 12.5523 13.5523 13 13 13H9.5V12Z"
        fill="#97B2C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C8.27614 2 8.5 2.20664 8.5 2.46154L8.5 13.5385C8.5 13.7934 8.27614 14 8 14C7.72386 14 7.5 13.7934 7.5 13.5385L7.5 2.46154C7.5 2.20664 7.72386 2 8 2Z"
        fill="#97B2C4"
      />
    </svg>
  )
}

export const IconSeismic2D = createIcon({
  l: IconSeismic2DS,
  m: IconSeismic2DS,
  s: IconSeismic2DS,
  xs: IconSeismic2DS,
  name: 'IconSeismic2D',
})
